import { OPERATIONAL_PERMISSIONS } from "../../../utils/constants";

/**
 * A user group is "operational" (eligible to be bound to a node group so its
 * members can operate the contained nodes) iff it carries at least one
 * operational permission. Pure admin / meta-management groups (only
 * "manage user groups" and/or "manage node groups") are not eligible.
 *
 * @param {{permissions?: string[]}} group user group object as returned by
 *   user.getAllUserGroup
 * @returns {boolean}
 */
export function isOperationalUserGroup(group) {
  if (!group || !Array.isArray(group.permissions)) return false;
  return group.permissions.some((p) => OPERATIONAL_PERMISSIONS.includes(p));
}
